import iconInfo from 'assets/images/icon-info.png';
import { styles } from 'consts';
import styled from 'styled-components';

const { errorColor, fontMontserrat, paymentColor } = styles;

const TitleContainer = styled.div`
  margin-top: 1.5rem;
  height: 1.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: ${errorColor};
`;

const ReasonContainer = styled.div`
  height: 1.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: ${paymentColor};
`;

const Icon = styled.img.attrs({
  alt: 'Paynow',
  src: iconInfo,
})`
  margin-right: 0.4375rem;
  height: 0.9375rem;
  width: 0.9375rem;
  object-fit: contain;
  vertical-align: middle;
`;

export { Icon, TitleContainer, ReasonContainer };
